import React from 'react';

import SEOLinks from '../../page/components/seo-links/seo-links';
import RelatedPages from '../../related-pages/components/related-pages';

import '../css/dlp-footer.less';

class DLPFooter extends React.Component {

  render(){
    const { pageInfo, match={}, wordCloud, hideRelatedPages } = this.props;


    return (
      <div className="dlp-footer">
          {
            !hideRelatedPages && (
              <RelatedPages
                pageInfo={pageInfo}
                keyword={`${match.params.slug}:relatedPages`}
                _source={['title', 'vanityUrl']}
                resultMapper={({_source}) => {
                  const { title: name, vanityUrl:url } = _source;
                  return {
                    name,
                    url: `/${url}`
                  }
                }}
              >
              {
                ({relatedPages}) => relatedPages && relatedPages.length > 0 && 
                    <div className="dlp-related-pages">
                      <SEOLinks links = {relatedPages} linkType={null}/>
                    </div>
              }
              </RelatedPages>
            )
        }
        {wordCloud && wordCloud.length > 0 && <SEOLinks links={wordCloud} /> }
      </div>
    );
  }

}

export default DLPFooter;
